interface CustomIconSmsChannelProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconSmsChannel({ width, height }: CustomIconSmsChannelProps) {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 4H6C4.89543 4 4 4.93207 4 6.08184V23.2515C4 24.4013 4.89543 25.3333 6 25.3333H14C15.1046 25.3333 16 24.4013 16 23.2515V6.08184C16 4.93207 15.1046 4 14 4Z"
        stroke="#1C1C28"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 8.66675H12V18.0001H24V8.66675Z"
        fill="white"
        stroke="#1C1C28"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15.3335 12H20.6668" stroke="#1C1C28" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15.3335 14.6667H20.6668"
        stroke="#1C1C28"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.6665 22.6667H11.3332" stroke="#1C1C28" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
